module.exports = __webpack_public_path__ + "img/analytics-marketing-team-1.d3d2a91c.svg";